/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_No_ApplicationsInputs */

const en_admin_user_detail_no_applications = /** @type {(inputs: Admin_User_Detail_No_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No applications yet.`)
};

const de_admin_user_detail_no_applications = /** @type {(inputs: Admin_User_Detail_No_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Bewerbungen.`)
};

/**
* | output |
* | --- |
* | "No applications yet." |
*
* @param {Admin_User_Detail_No_ApplicationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_no_applications = /** @type {((inputs?: Admin_User_Detail_No_ApplicationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_No_ApplicationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_no_applications(inputs)
	return en_admin_user_detail_no_applications(inputs)
});